// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDashboardVoidStatusCard_root__LWh65","text":"PlasmicDashboardVoidStatusCard_text__MRX4N"};